<title>courses.title</title>
<layout>layout.courses</layout>
<template>
  <div>
    <div class="row">
      <div class="column large-3">
        <div class="row nested-row">
          <div class="course__filters column panel bg-white radius">
            <input
              v-model="query"
              :placeholder="t('courses.search_placeholder')"
              type="search"
              class="radius no-margin">
            <div v-for="group in filterableTagGroups">
              <div
                :class="{
                  'course__filters__title': true,
                  'course__filters__title--open': !isCollapsed(group.title)
                }"
                :title="getHoverText(group.title)"
                @click="toggleCollapse(group.title)">
                <strong
                  class="text-red"
                  style="text-transform: uppercase;"
                  v-text="group.title"/>
                <i
                  :class="getGroupClasses(group.title)"
                  aria-hidden="true"/>
              </div>

              <ul
                v-if="!isCollapsed(group.title)"
                class="select-list fa-ul">
                <li v-for="tag in group.tags">
                  <label>
                    <input
                      :value="tag.id"
                      v-model="filteredTags"
                      class="no-margin"
                      type="checkbox">
                    <i class="fa fa-li text-gray"/>
                    <span v-text="tag.title"/>
                  </label>
                </li>
              </ul>
              <hr class="course__filters__divider">
            </div>
            <div>

              <div
                :class="{
                  'course__filters__title': true,
                  'course__filters__title--open': !isCollapsed('providers')
                }"
                :title="getHoverText('providers')"
                @click="toggleCollapse('providers')">
                <strong
                  class="text-red"
                  style="text-transform: uppercase;"
                  v-text="t('courses.course_providers')"/>
                <i
                  :class="getGroupClasses('providers')"
                  aria-hidden="true"/>
              </div>

              <ul
                v-if="!isCollapsed('providers')"
                class="select-list fa-ul">
                <li v-for="provider in filterableProviders">
                  <label>
                    <input
                      :value="provider.name"
                      v-model="filteredProviders"
                      class="no-margin"
                      type="checkbox">
                    <i class="fa fa-li text-gray"/>
                    <span v-text="provider.name"/>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="column large-9 course__list">
        <div class="row nested-row">
          <div class="column">
            <p v-if="hasFilters">
              {{
                t('courses.displaying_number_of_filtered_courses', {
                  filtered: displayedCourses.length,
                  total: courses.length
                })
              }}
              <a
                class="right"
                @click="clearFilters">
                {{ t('courses.clear_filters') }} <i class="fa fa-times fa-fw text-blue"/>
              </a>
            </p>
            <p v-else>
              {{
                t('courses.displaying_number_of_total_courses', {
                  total: courses.length
                })
              }}
            </p>
          </div>
        </div>
        <div
          v-for="row in rows"
          class="row nested-row">
          <div
            v-for="course in row"
            :class="[
              'column',
              'small-' + 12 / itemsPerRow,
              'end'
            ]"
            style="margin-bottom: 1.875rem; cursor: pointer;"
            @click="showCourse(course)"
          >
            <div class="course">
              <div
                :class="{
                  'course__image': true,
                  'course__image--bc': course.isBc,
                  'course__image--property-management': course.isPropertyManagement
                }"
                :data-property-management="t('courses.property_management_label')"
                data-bc="BC">
                <img
                  :src="course.imageUrl"
                  class="course__image-img"
                  @error="onCourseImageError($event, course)">
              </div>
              <div class="panel bg-white no-margin course__label">
                <h6
                  class="text-blue"
                  v-text="course.title"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-if="courseModal.isShowing"
      :show-close-button="true"
      size="medium"
      @close="courseModal.isShowing = false"
    >
      <div class="row">
        <div class="column large-4">
          <div class="hide-for-large-up">
            <button
              :disabled="!hasPreviousCourse"
              :title="t('courses.modal_previous')"
              class="tiny secondary radius"
              @click="showPreviousCourse">
              <i
                class="fa fa-chevron-left"
                aria-hidden="true"/>
            </button>
            <button
              :disabled="!hasNextCourse"
              :title="t('courses.modal_next')"
              class="tiny secondary radius"
              @click="showNextCourse">
              <i
                class="fa fa-chevron-right"
                aria-hidden="true"/>
            </button>
          </div>

          <div
            :class="{
              'course-modal__image-holder': true,
              'course-modal__image-holder--bc': courseModal.course.isBc,
              'course-modal__image-holder--property-management':
                courseModal.course.isPropertyManagement
            }"
            :data-property-management="t('courses.property_management_label')"
            data-bc="BC">
            <img
              :src="courseModal.course.imageUrl"
              class="course-modal__image"
              @error="onCourseImageError($event, courseModal.course)">
          </div>

          <p class="text-dark-gray no-margin">{{ t('courses.course_provided_by') }}</p>

          <img
            :src="logo(courseModal.course.providerId)"
            class="course-modal__provider-logo">
        </div>
        <div class="column large-8">
          <div class="show-for-large-up">
            <button
              :disabled="!hasPreviousCourse"
              :title="t('courses.modal_previous')"
              class="tiny secondary radius"
              @click="showPreviousCourse">
              <i
                class="fa fa-chevron-left"
                aria-hidden="true"/>
            </button>
            <button
              :disabled="!hasNextCourse"
              :title="t('courses.modal_next')"
              class="tiny secondary radius"
              @click="showNextCourse">
              <i
                class="fa fa-chevron-right"
                aria-hidden="true"/>
            </button>
          </div>

          <h3 v-text="courseModal.course.title"/>

          <p v-if="isEnglishOnly(courseModal.course)">
            <i>{{ t('courses.available_in_english_only') }}</i>
          </p>

          <h5>{{ t('courses.course_fee') }}</h5>
          <p v-text="courseModal.course.cost"/>

          <h5>{{ t('courses.course_description') }}</h5>
          <p v-html="courseModal.course.description"/>

          <template v-for="group in courseModal.tagGroups">
            <h5 v-text="group.name"/>
            <p>
              <template v-for="(tag, index) in group.tags">
                <span v-text="tag"/><template v-if="index !== group.tags.length - 1">, </template>
              </template>
            </p>
          </template>

          <div class="hide-for-large-up">
            <p v-if="courseModal.course.documentUrl.length">
              <a
                :href="courseModal.course.documentUrl"
                target="_blank">
                {{ t('courses.view_course_outline') }}
              </a>
            </p>

            <a
              :href="courseModal.course.purchaseUrl"
              target="_blank"
              class="button tiny radius no-margin">{{ t('courses.buy_course') }}</a>
          </div>

          <div class="show-for-large-up">
            <a
              :href="courseModal.course.purchaseUrl"
              target="_blank"
              class="button tiny radius no-margin">{{ t('courses.buy_course') }}</a>
            <a
              v-if="courseModal.course.documentUrl.length"
              :href="courseModal.course.documentUrl"
              target="_blank"
              style="margin-left: 15px;"
            >
              {{ t('courses.view_course_outline') }}
            </a>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import Fuse from 'fuse.js';
import Modal from '../components/Ui/Modal.vue';

const VERIFORCE_CANADA_PROVIDER_ID = 16;

export default {

  components: {
    Modal,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  data() {
    const filterableProviders = _.map(
      _.groupBy(this.data.providers, 'name'),
      (group, key) => ({
        name: key,
        ids: _.map(group, 'id'),
      })
    );

    const filterableTagGroups = _.map(
      this.data.tagGroups,
      (tags, title) => ({
        title,
        tags: _.orderBy(tags, 'ordinal'),
      })
    );

    return {
      courses: this.data.courses,
      tagGroups: this.data.tagGroups,
      filterableTagGroups,
      providers: this.data.providers,
      filterableProviders,
      collapsedGroups: {},
      filteredTags: ['16'],
      filteredProviders: ['Veriforce-Canada'],
      query: '',
      pageWidth: 0,
      courseModal: {
        isShowing: false,
        course: {},
        tagGroups: [],
      },
    };
  },

  computed: {
    hasFilters() {
      return false
        || this.query.length
        || this.filteredTags.length
        || this.filteredProviders.length;
    },

    itemsPerRow() {
      if (this.pageWidth > 1200) {
        return 4;
      }
      if (this.pageWidth > 1024) {
        return 3;
      }
      if (this.pageWidth > 550) {
        return 2;
      }
      return 1;
    },

    currentCourseIndex() {
      return _.findIndex(this.displayedCourses, this.courseModal.course);
    },

    hasNextCourse() {
      return this.displayedCourses[this.currentCourseIndex + 1] !== undefined;
    },

    hasPreviousCourse() {
      return this.displayedCourses[this.currentCourseIndex - 1] !== undefined;
    },

    displayedCourses() {
      const query = this.query.toLowerCase();

      const filteredProviders = _.flatten(this.filterableProviders
        .filter(group => _.includes(this.filteredProviders, group.name))
        .map(group => group.ids));

      const hasTags = this.filteredTags.length > 0;
      const hasProviders = filteredProviders.length > 0;

      const courses = this.courses.filter((course) => {
        const passesTags = !hasTags || !_.difference(this.filteredTags, course.tags).length;
        const passesProviders = !hasProviders || _.includes(filteredProviders, course.providerId);

        if (hasTags && hasProviders) {
          return passesTags || passesProviders;
        }

        return passesTags && passesProviders;
      });

      const options = {
        shouldSort: true,
        threshold: 0.5,
        location: 0,
        distance: 2000,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          'description',
          'title',
          'cost',
        ],
      };

      return query.length ? new Fuse(courses, options).search(query) : courses;
    },

    rows() {
      return _.chunk(this.displayedCourses, this.itemsPerRow);
    },
  },

  watch: {
    filteredTags(newTags, oldTags) {
      const wasPopular = _.includes(oldTags, '16');
      const isPopular = _.includes(newTags, '16');

      if (isPopular && !wasPopular) {
        if (!_.includes(this.filteredProviders, 'Veriforce-Canada')) {
          this.filteredProviders.push('Veriforce-Canada');
        }
      } else if (!isPopular && wasPopular) {
        this.filteredProviders = this.filteredProviders.filter(p => p !== 'Veriforce-Canada');
      }
    },
  },

  mounted() {
    this.updatePageWidth();

    $(window).resize(() => {
      this.updatePageWidth();
    });

    $(window).on('keydown', this.handleGlobalKeyDown);
  },

  destroyed() {
    $(window).off('keydown', this.handleGlobalKeyDown);
  },

  methods: {
    logo(providerId) {
      if (this.providers[providerId]) {
        return this.providers[providerId].logo;
      }

      return false;
    },

    onCourseImageError(event, course) {
      if (event.target.dataset.fallbackUsed) return;
      event.target.dataset.fallbackUsed = 'true';
      if (course && course.providerId === VERIFORCE_CANADA_PROVIDER_ID) {
        event.target.src = '/img/veriforce-symbol-colour-RGB.png';
      } else {
        event.target.src = '/public/courses/default.png';
      }
    },

    showCourse(course) {
      this.courseModal.course = course;
      this.courseModal.isShowing = true;
      this.courseModal.tagGroups = [];

      _.each(this.tagGroups, (group, name) => {
        const tagIds = _.intersection(_.keys(group), course.tags);

        const tags = _.map(tagIds, tagId => group[tagId].title);

        if (tags.length) {
          this.courseModal.tagGroups.push({
            name,
            tags,
          });
        }
      });
    },

    showNextCourse() {
      if (this.hasNextCourse) {
        this.showCourse(this.displayedCourses[this.currentCourseIndex + 1]);
      }
    },

    showPreviousCourse() {
      if (this.hasPreviousCourse) {
        this.showCourse(this.displayedCourses[this.currentCourseIndex - 1]);
      }
    },

    clearFilters() {
      this.query = '';
      this.filteredTags = [];
      this.filteredProviders = [];
    },

    toggleCollapse(title) {
      this.$set(this.collapsedGroups, title, !this.collapsedGroups[title]);
    },

    getGroupClasses(title) {
      return [
        'course__filters__title__caret',
        'fa',
        this.isCollapsed(title) ? 'fa-caret-left' : 'fa-caret-down',
        'text-blue',
        'right',
      ];
    },

    isCollapsed(title) {
      return !!this.collapsedGroups[title];
    },

    getHoverText(title) {
      return this.isCollapsed(title)
        ? t('courses.filters_expand')
        : t('courses.filters_collapse');
    },

    isEnglishOnly(course) {
      return course.title.indexOf('(Français)') === -1;
    },

    updatePageWidth() {
      const oldWidth = this.pageWidth;
      const newWidth = $(window).width();

      const exitedMobile = newWidth >= 1010 && (oldWidth <= 1009 || oldWidth === 0);
      const enteredMobile = (oldWidth >= 1010 || oldWidth === 0) && newWidth <= 1009;

      if (exitedMobile) {
        this.collapsedGroups = {};
      }

      if (enteredMobile) {
        this.collapsedGroups = { providers: true };

        _.keys(this.tagGroups).forEach((title) => {
          this.$set(this.collapsedGroups, title, true);
        });
      }

      this.pageWidth = newWidth;
    },

    handleGlobalKeyDown(event) {
      const key = {
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        esc: 27,
      };

      if (!this.courseModal.isShowing) {
        return;
      }

      switch (event.keyCode) {
        case key.left:
          this.showPreviousCourse();
          break;
        case key.right:
          this.showNextCourse();
          break;
        case key.up:
          _.times(this.itemsPerRow, this.showPreviousCourse);
          break;
        case key.down:
          _.times(this.itemsPerRow, this.showNextCourse);
          break;
        case key.esc:
          this.courseModal.isShowing = false;
          break;
        default:
          break;
      }
    },
  },
};
</script>
